export default "__VITE_ASSET__iB3_p2EA__"